import { useContext, useEffect, useState, useCallback } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { EditableContext } from "common/EditableContextProvider";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isValidPhoneNumber } from "react-phone-number-input";
import { Checkbox } from "antd";

export const FormComponent = () => {
    const { context } = useContext(EditableContext);
    const { FormBase } = context;
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const defaultItem = {
        id: 0,
        name: "",
        number: "",
        blocked: null,
    };

    useEffect(() => {
        setInitialValues(getInitialValues());
    }, [context.editID]);

    const getInitialValues = useCallback(() => {
        let it = context.getItemSelected();
        if (!it) {
            it = defaultItem;
        } else {
            it = { ...it };
        }
        return it;
    }, [context.editID]);

    const validateSchema = Yup.object({
        name: Yup.string().required("El campo es obligatorio"),
        number: Yup.string()
            .required("El campo es obligatorio")
            .test("number", "El número es incorrecto", (value) =>
                isValidPhoneNumber(`+${value}` || "")
            ),
    });

    const handleSubmit = async (values, formik) => {
        try {
            setIsLoading(true);
            let id = await context.saveItem(values);
            if (id) {
                formik.setFieldValue("id", id);
                setInitialValues((prev) => ({ ...prev, ...values, id: id }));
            } else {
                setInitialValues((prev) => ({ ...prev, ...values }));
            }
        } catch (error) {
            const { errors } = error.response.data;
            let keys = Object.keys(errors);
            keys.forEach((key) => {
                formik.setFieldError(key, errors[key][0]);
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validateSchema}
            enableReinitialize={true}
        >
            {(formik) => (
                <Form>
                    <fieldset disabled={FormBase.isLoading}>
                        <div className="mb-2">
                            <FormBase.FormTextField
                                formik={formik}
                                label="Nombre"
                                id="name"
                                required={true}
                            />
                        </div>
                        <div className="mb-2">
                            <PhoneInput
                                international
                                defaultCountry="BO"
                                value={
                                    formik.values.number
                                        ? `+${formik.values.number}`
                                        : ""
                                }
                                onChange={(value) =>
                                    formik.setFieldValue(
                                        "number",
                                        value ? value.slice(1) : ""
                                    )
                                }
                                placeholder="Enter phone number"
                            />

                            <ErrorMessage
                                name="number"
                                component={context.FormBase.FormError}
                            />
                        </div>

                        <div className="my-3">
                            <Checkbox
                                checked={formik.values.blocked ?? false}
                                onChange={(e) =>
                                    formik.setFieldValue(
                                        "blocked",
                                        e.target.checked
                                    )
                                }
                            >
                                Bloqueado
                            </Checkbox>
                        </div>

                        <div className="mb-2">
                            <div className="row">
                                <div className="col">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger w-100"
                                        onClick={() =>
                                            context.modalBase.close()
                                        }
                                    >
                                        Cancelar
                                    </button>
                                </div>
                                <div className="col">
                                    <button
                                        type="submit"
                                        className="btn btn-sm btn-dark w-100"
                                        disabled={isLoading || !formik.dirty}
                                    >
                                        {isLoading ? "Guardando..." : "Guardar"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </Form>
            )}
        </Formik>
    );
};
